import React, { useState } from "react";
import { useHistory } from "react-router";
import { Button } from "Components/ReactstrapSlim";
import { Module } from "Components/Module";
import GetHelpModal from "../GetHelpModal";


export const QuestionsModule: React.FC = () => {
   const history = useHistory();   
   
   const [isSupportModalOpen, setIsSupportModalOpen] = useState(false);  

   const toggleSupportModal = () => {
      setIsSupportModalOpen(!isSupportModalOpen);
   }  
 
   return (<Module size="lg" className="module-questions">
      <div className="module-questions-content">
         <div className="module-questions-caption">Questions?</div>
         <div className="module-questions-text">Check out the FAQ section to learn more about the program.</div>
      </div>
      <div className="module-questions-cta">         
         <Button color="primary-on-ocean" size="lg" fluid="sm" onClick={() => history.push("/help")}>FAQ</Button>
         <Button color="secondary-on-ocean" size="lg" fluid="sm" onClick={() => toggleSupportModal()}>Get help</Button>
      </div>      
      <GetHelpModal isOpen={isSupportModalOpen} toggle={toggleSupportModal} closeModal={toggleSupportModal} />      
   </Module>);
}